enum Country {
  SWITZERLAND = "CH",
  GERMANY = "DE",
  SPAIN = "ES",
  ITALY = "IT",
  USA = "US",
}
export default Country;
